import { useContext } from "react";
import ReactGraphicsContext from "./ReactGraphicsContext";

const usePixiApp = () => {
  const value = useContext(ReactGraphicsContext);
  if (!value) {
    throw new Error("usePixiApp can only be used inside <Canvas />");
  }
  return value.pixiApp;
};

export default usePixiApp;
